import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { Typography } from "@mindlercare/ui-web";

export const TasksTitles = () => {
  const { t } = useTranslation();

  return (
    <TitleRow>
      <Typography variant="body-x-small" color="DARK_GREY">
        {t("TASKS_TITLE.RESPONSE")}
      </Typography>
      <Typography variant="body-x-small" color="DARK_GREY">
        {t("TASKS_TITLE.PATIENT")}
      </Typography>
      <Typography variant="body-x-small" color="DARK_GREY">
        {t("PROGRAM_TITLE")}
      </Typography>
      <Typography variant="body-x-small" color="DARK_GREY">
        {t("PATIENT_NOTES")}
      </Typography>
      <Typography variant="body-x-small" color="DARK_GREY">
        {t("TASKS_TITLE.STATUS")}
      </Typography>
      <Typography variant="body-x-small" color="DARK_GREY">
        {t("FEEDBACK_DATE")}
      </Typography>
    </TitleRow>
  );
};

const TitleRow = styled.li`
  margin: 16px 0 8px 32px;
  display: flex;
  justify-content: space-between;
  align-items: left;
  & > * {
    flex: 1;
  }
`;
